var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modalDuplicate"},[_c('div',{staticClass:"card",staticStyle:{"border-radius":"10px","padding":"10px"}},[_c('img',{staticClass:"icon-close",attrs:{"src":require("@/assets/img/icons/close-icon.png"),"alt":"close-icon"},on:{"click":function($event){return _vm.closeModalDuplicate()}}}),_c('h2',{staticStyle:{"font-size":"14px"}},[_vm._v("\n      "+_vm._s(_vm.$t("meeting.duplicate.title", {
          name:
            _vm.modalDuplicate.insight !== null &&
            _vm.modalDuplicate.insight !== undefined
              ? _vm.modalDuplicate.insight.name
              : "",
        }))+"\n    ")]),_c('hr'),_c('PopupDuplicate',{attrs:{"outil":"profeel","row":_vm.modalDuplicate.insight}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }